module.exports = __webpack_public_path__ + "static/chats-manager-icon-d0d03cdb678859c7b62ef71b8e10f9ee.png";